import { createAction, props } from '@ngrx/store';
import { LocationModel } from '../backend/location/model/location.model';

export const RequestAllLocationsAction = createAction('[Location] Request All');

export const ReceiveAllLocationsAction = createAction(
  '[Location] Receive All',
  props<{ payload: { Location: LocationModel[] } }>()
);
